import { render, staticRenderFns } from "./AlbumPickZone.vue?vue&type=template&id=69783712&scoped=true&"
import script from "./AlbumPickZone.vue?vue&type=script&lang=js&"
export * from "./AlbumPickZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumPickZone.vue?vue&type=style&index=0&id=69783712&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69783712",
  null
  
)

export default component.exports